export default __webpack_public_path__ + "static/media/034-wedding-cake.b254089c.png";